import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { useWarehouseContext } from "../../contexts"
import { formatTime, getWarehouseTypeLabel } from "../../utils"

const WarehouseInfo: FC = () => {
  const warehouse = useWarehouseContext()
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <Accordion
      elevation={0}
      slotProps={{ heading: { component: "h2" } }}
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      <AccordionSummary expandIcon={<KeyboardArrowDownOutlined />}>
        <Typography variant='subtitle1' component='span'>
          Warehouse Information
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box className='flex flex-col gap-y-6'>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Warehouse Type</TableCell>
                <TableCell>Receiving Hours</TableCell>
                <TableCell>Shipping Hours</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className='w-[13.375rem]' data-testid='warehouse-type'>
                  {getWarehouseTypeLabel(warehouse.type)}
                </TableCell>
                <TableCell className='w-[13.375rem]' data-testid='warehouse-receiving-hours'>
                  {warehouse.receivingHoursFrom && warehouse.receivingHoursTo
                    ? `${formatTime(warehouse.receivingHoursFrom)} to ${formatTime(warehouse.receivingHoursTo)}`
                    : ""}
                </TableCell>
                <TableCell data-testid='warehouse-shipping-hours'>
                  {warehouse.shippingHoursFrom && warehouse.shippingHoursTo
                    ? `${formatTime(warehouse.shippingHoursFrom)} to ${formatTime(warehouse.shippingHoursTo)}`
                    : ""}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          {warehouse.specialInstructions && (
            <Box className='flex flex-col gap-y-6 rounded-md border border-gray-300 p-6'>
              <Typography variant='subtitle1' component='h3'>
                Instructions
              </Typography>
              <Typography variant='body2' data-testid='warehouse-instructions'>
                {warehouse.specialInstructions}
              </Typography>
            </Box>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default WarehouseInfo
